/*
 * Copyright (c) Akveo 2019. All Rights Reserved.
 * Licensed under the Single Application / Multi Application License.
 * See LICENSE_SINGLE_APP / LICENSE_MULTI_APP in the 'docs' folder for license information on type of purchased license.
 */

import { Injectable } from '@angular/core';
import { NbAuthService } from '@nebular/auth';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router} from '@angular/router';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';

@Injectable()
export class AuthGuard implements CanActivate {
  constructor(private authService: NbAuthService, private router: Router) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<boolean> | Promise<boolean> | boolean {
    // isAuthenticated() only looks at the access token, which lives 60 minutes: after that, the first
    // navigation without an API call in between bounced a signed-in user to the login page. The
    // refresh token is still good, so renew first - same call NbAuthJWTInterceptor makes for requests.
    return this.authService.isAuthenticatedOrRefresh()
      .pipe(
        tap(authenticated => {
          if (!authenticated) {
            const isPatient = localStorage.getItem("loginuser") === "patientlogin";
          const isInsurance = localStorage.getItem("InsuranceFlag") === "true"?true:false;
          const type = localStorage.getItem('PatloginUserType');
          // WellSpring/"Second Opinion" sessions (Patient/Doctor/Care Navigator/Reviewer) also
          // set InsuranceFlag=true (see TenantRoleLoginService) but never PatloginUserType (only
          // the legacy Care-Sphere login sets that) - checked ahead of isInsurance so an expired
          // WellSpring session bounces back to its own well-spring-login instead of the broken
          // `auth/care-sphere/null` a bare isInsurance check would produce here.
          const isWellSpring = localStorage.getItem('WellSpringAppFlag') === 'true' && !type;

          if (isWellSpring) {
            const tenantAlias = localStorage.getItem('tenantAlias');
            const employeeRoleUrlSuffix = localStorage.getItem('employeeRoleUrlSuffix');
            if (tenantAlias && employeeRoleUrlSuffix) {
              this.router.navigate([`auth/well-spring-login/${tenantAlias}/${employeeRoleUrlSuffix}`]);
            } else if (tenantAlias) {
              this.router.navigate([`auth/well-spring-login/${tenantAlias}`]);
            } else {
              this.router.navigate(['auth/well-spring-login']);
            }
          }
          else if (isPatient && !isInsurance) {
            this.router.navigate(['auth/patient-portal']);
          }
          else if (isInsurance) {
            this.router.navigate([`auth/care-sphere/${type}`]);
          }else {
            this.router.navigate(['auth/login']);
          }
          }
        }),
      );

  }
}
